export default "__VITE_ASSET__1K3CCDdR__";